var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"help-page"},[_c('div',{staticClass:"help"},[_c('div',{staticClass:"help-title"},[_vm._v("隐私政策")]),_c('div',{staticClass:"help-box1",domProps:{"innerHTML":_vm._s(_vm.info.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }